'use client'

import { TopBannerDefaults } from './TopBanner.defaults'
import { type TopBannerProps } from './TopBannerProps'

export const TopBanner = (props: TopBannerProps = TopBannerDefaults) => {
  const { children, isSticky, backgroundColor, textColor, height } = props
  return (
    <div
      data-builder-component="top-banner"
      className="top-0 left-0 z-50 flex w-full items-center justify-center py-2"
      style={{
        position: isSticky ? 'fixed' : 'absolute',
        backgroundColor,
        color: textColor,
        height,
      }}
    >
      {children}
    </div>
  )
}
